"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withForm;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function withForm(formProps, Form) {
  /**
   * Default handlers
   */
  const defFormProps = {
    handleSubmit: () => {},
    handleErrors: () => {},
    handleOnChange: field => field,
    setValues: values => values,
    mapPropsToValues: () => ({}),
    defaultErrorMsg: {},
    validate: () => ({}),
    yup: null
  };

  /**
   * Handlers merge
   */
  const customFormProps = Object.assign({}, defFormProps, formProps);

  /**
   * HOC for handle form
   */
  class WithForm extends _react.default.Component {
    constructor(props) {
      super(props);
      this.state = {
        values: customFormProps.mapPropsToValues(props),
        errors: {},
        isSubmit: false
      };
      this.setSubmitting = this.setSubmitting.bind(this);
      this.setErrors = this.setErrors.bind(this);
      this.setValues = this.setValues.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleOnChange = this.handleOnChange.bind(this);
      this.removeError = this.removeError.bind(this);
      this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    // Handler on change field/fields
    handleOnChange(fields) {
      const newValues = {};
      const valuesErrors = {};

      // One or multiple fields could be set at one time
      (Array.isArray(fields) ? fields : [fields]).forEach(field => {
        const {
          id,
          value,
          error
        } = customFormProps.handleOnChange(field, this.props);
        newValues[id] = value;
        valuesErrors[id] = error ? this.getDefaultErrorMsg(id) : null;
      }, {});
      const values = _objectSpread(_objectSpread({}, this.state.values), newValues);
      this.setValues(values);
      if (Object.values(valuesErrors).some(Boolean)) {
        this.setErrors(valuesErrors);
      } else {
        this.removeError(Object.keys(valuesErrors));
      }
    }

    // Handler on submit form
    handleSubmit(arg, options = {
      skipValidation: false
    }) {
      var _this = this;
      return (0, _asyncToGenerator2.default)(function* () {
        const {
          dispatch
        } = _this.props;
        const {
          values,
          errors
        } = _this.state;
        if (!options.skipValidation) {
          const validationErrors = yield _this.runValidation(values);
          const allErrors = Object.assign({}, errors, validationErrors);
          _this.setErrors(allErrors);
          const findErrors = Object.keys(allErrors).filter(key => !!allErrors[key]);
          if (findErrors.length > 0) {
            customFormProps.handleErrors(allErrors, values, dispatch, {
              setSubmitting: _this.setSubmitting,
              setErrors: _this.setErrors,
              setValues: _this.setValues
            }, _this.props, arg);
            return;
          }
        }
        _this.setSubmitting(true);
        customFormProps.handleSubmit(values, dispatch, {
          setSubmitting: _this.setSubmitting,
          setErrors: _this.setErrors,
          setValues: _this.setValues
        }, _this.props, arg);
      })();
    }

    // Handler on field key press
    handleKeyPress(e) {
      if (customFormProps.handleKeyPress) {
        customFormProps.handleKeyPress(e, this.props, {
          setSubmitting: this.setSubmitting,
          setErrors: this.setErrors,
          setValues: this.setValues,
          handleSubmit: this.handleSubmit,
          handleOnChange: this.handleOnChange
        });
      } else if (e && e.key === 'Enter') {
        this.handleSubmit();
      }
    }

    // Set form status
    setSubmitting(isSubmit) {
      this.setState({
        isSubmit
      });
    }

    // Set error message from defaultErrorMsg
    getDefaultErrorMsg(id) {
      const defaultErrorMsg = customFormProps.defaultErrorMsg;
      return defaultErrorMsg[id] || 'Incorrect data';
    }

    // Set fileds errors
    setErrors(errors) {
      this.setSubmitting(false);
      this.setState({
        errors: _objectSpread(_objectSpread({}, this.state.errors), errors)
      });
    }

    // Remove error from fields
    removeError(ids) {
      const errors = Object.assign({}, this.state.errors);

      // One or multiple errors could be set at one time
      (Array.isArray(ids) ? ids : [ids]).forEach(id => delete errors[id]);
      this.setState({
        errors
      });
    }

    // Set fields values
    setValues(values) {
      values = customFormProps.setValues(values);
      this.setState({
        values: _objectSpread(_objectSpread({}, this.state.values), values)
      });
    }

    // Form validation
    runValidation(values) {
      var _this2 = this;
      return (0, _asyncToGenerator2.default)(function* () {
        const customValidator = customFormProps.validate(values);
        if (customFormProps.yup) {
          try {
            const yup = typeof customFormProps.yup === 'function' ? customFormProps.yup(_this2.props) : customFormProps.yup;
            yield yup.validate(values, {
              abortEarly: false
            });
          } catch (e) {
            const yupError = _this2.yupToFormErrors(e);
            return Object.assign({}, yupError, customValidator);
          }
        }
        return customValidator;
      })();
    }

    // Convert errors from YUP to form format
    yupToFormErrors(yupError) {
      const errors = {};
      for (const err of yupError.inner) {
        // eslint-disable-line
        if (err.path) {
          errors[err.path] = err.message;
        }
      }
      return errors;
    }
    render() {
      return /*#__PURE__*/_react.default.createElement(Form, (0, _extends2.default)({}, this.props, this.state, {
        setValues: this.setValues,
        setErrors: this.setErrors,
        removeError: this.removeError,
        handleOnChange: this.handleOnChange,
        handleSubmit: this.handleSubmit,
        handleKeyPress: this.handleKeyPress
      }));
    }
  }
  return WithForm;
}